import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { RestClientService } from '@app/app/shared/services/rest-client.service';
import { environment } from '@app/environments/environment';
import { TranslocoService } from '@ngneat/transloco';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EmployerMemberDataService, MemberResultsResponse, MemberSummaryResponse, ProgramListItem } from './employer-member-data.service';

@Injectable()
export class ApiEmployerMemberDataService implements EmployerMemberDataService {
  constructor(
    private readonly client: RestClientService,
    private readonly transloco: TranslocoService,
  ) {}

  getPrograms(masterOnly = true): Observable<ProgramListItem[]> {
    return this.client
      .get<
        ProgramListItem[]
      >(Location.joinWithSlash(environment.apiRootUrl || '', `analytics/programs`), { masterOnly: String(masterOnly) })
      .pipe(
        map(({ body }) => body as ProgramListItem[]),
        catchError(() => throwError(() => new Error(this.transloco.translate('translations.errors.errorGetEmployerPrograms')))),
      );
  }

  getMemberSummary(programId: string, memberUid: string): Observable<MemberSummaryResponse> {
    return this.client
      .get<MemberSummaryResponse>(
        Location.joinWithSlash(environment.apiRootUrl || '', `analytics/programs/${programId}/members/${memberUid}/summary`),
      )
      .pipe(
        map(({ body }) => body as MemberSummaryResponse),
        catchError(() => throwError(() => new Error(this.transloco.translate('translations.errors.errorGetMemberSummary')))),
      );
  }

  getMemberResults(programId: string, memberUid: string): Observable<MemberResultsResponse> {
    return this.client
      .get<MemberResultsResponse>(
        Location.joinWithSlash(environment.apiRootUrl || '', `analytics/programs/${programId}/members/${memberUid}/results`),
      )
      .pipe(
        map(({ body }) => body as MemberResultsResponse),
        catchError(() => throwError(() => new Error(this.transloco.translate('translations.errors.errorGetMemberResults')))),
      );
  }
}
